module.exports = __webpack_public_path__ + "static/media/doubleDog5.7cf2d094.png";